export default "__VITE_ASSET__B76Rs7ME__"